import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import { IconTypes } from '~/components/Icon/IconTypes';
import { userStore } from '~/stores/UserStore';
import { formatPriceWithCurrency } from '~/utils/formaters';

import { Step } from '../../interfaces';

import styles from './StepItem.module.scss';

interface StepItemProps {
  item: Step;
}

const StepItem = ({ item }: StepItemProps) => {
  const { t } = useTranslation();

  return (
    <li className={styles.ruleItem} key={item.title}>
      <p className={styles.title}>
        <Icon type={item.icon as IconTypes} size={24} /> {t(item.title)}
      </p>
      <p className={styles.description}>
        {t(item.description, {
          discount: userStore.loyaltyPointsStore.terms.paymentAmount,
          rate: userStore.loyaltyPointsStore.terms.rate,
          currency: formatPriceWithCurrency(1),
        })}
      </p>
    </li>
  );
};

export default observer(StepItem);
